import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import s from './Dropdown.module.scss';
import Icon from '../Icon';
import classNames from 'classnames';
import { AnimateUpDown } from '../Animate/Animate';

const Dropdown = ({
    title = '',
    children,
    modifiers = [],
    showCheckmark = false,
    isOpen: externalIsOpen = false,
    onToggle = null,
    showShadow = false,
    description,
    disabled = false,
}) => {
    const [isOpen, setIsOpen] = useState(externalIsOpen);

    useEffect(() => {
        setIsOpen(externalIsOpen);
    }, [externalIsOpen]);

    const toggleDropdown = () => {
        const newIsOpen = !isOpen;
        setIsOpen(newIsOpen);
        if (onToggle) {
            onToggle(newIsOpen);
        }
    };

    const classes = classNames(
        s.Root,
        modifiers.map((modifier) => s[`Root--${modifier}`]),
        {
            [s['Root--Open']]: isOpen,
            [s['Root--Shadow']]: showShadow && isOpen,
            [s['Root--Disabled']]: disabled,
        }
    );

    return (
        <div className={classes}>
            <div className={s.Header} onClick={toggleDropdown}>
                <div className={s.TitleWrapper}>
                    {showCheckmark && (
                        <Icon
                            className={s.Checkmark}
                            name="CheckSmallBlackBackground"
                        />
                    )}
                    <span className={s.Title}>
                        {title}
                        {description && (
                            <span className={s.Description}>{description}</span>
                        )}
                    </span>
                </div>

                <Icon className={s.Icon} name="ArrowRight" />
            </div>
            <AnimateUpDown isVisible={isOpen}>
                <div className={s.Content}>{children}</div>
            </AnimateUpDown>
        </div>
    );
};

Dropdown.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    modifiers: PropTypes.arrayOf(PropTypes.string),
    showCheckmark: PropTypes.bool,
    isOpen: PropTypes.bool, // New prop
    onToggle: PropTypes.func,
};

export default Dropdown;
